import _ from 'lodash'

export const getSkillText = (Skills) => {
  let skillText = ''
  _.forEach(Skills, (Skill) => {
    if (skillText === '') {
      skillText = `${Skill}`
    } else {
      skillText = `${skillText}, ${Skill}`
    }
  })
  return skillText
}

export const getSkillLevels = (Levels) => {
  let skillLevel = ''
  _.forEach(Levels, (level) => {
    if (skillLevel === '') {
      skillLevel = `${level.Code}`
    } else {
      skillLevel = `${skillLevel}, ${level.Code}`
    }
  })
  return skillLevel
}
